import script from "./CharacterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacterForm.vue?vue&type=script&setup=true&lang=js"

import "./CharacterForm.vue?vue&type=style&index=0&id=985cee16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-985cee16"]])

export default __exports__